// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__dytsG"};